var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C8.175 9 7.5 8.325 7.5 7.5C7.5 6.675 8.175 6 9 6C9.825 6 10.5 6.675 10.5 7.5C10.5 8.325 9.825 9 9 9ZM13.5 7.65C13.5 4.9275 11.5125 3 9 3C6.4875 3 4.5 4.9275 4.5 7.65C4.5 9.405 5.9625 11.73 9 14.505C12.0375 11.73 13.5 9.405 13.5 7.65ZM9 1.5C12.15 1.5 15 3.915 15 7.65C15 10.14 12.9975 13.0875 9 16.5C5.0025 13.0875 3 10.14 3 7.65C3 3.915 5.85 1.5 9 1.5Z",
    fill: "#C0D0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/Location_icon.5ec156527705ee81348a2358cb6e9057.svg";
export { ForwardRef as ReactComponent };